<template>
  <div class="region-rank">
    <table class="region-table">
      <tr class="region-row">
        <td colspan="4" class="region-cell region">{{ regionInfo.displayRegion }}</td>
      </tr>
      <tr>
        <td colspan="2" class="region-cell apple store">AppStore</td>
        <td colspan="2" class="region-cell google store">GooglePlay</td>
      </tr>
      <tr>
        <td class="region-cell apple">
          <a v-if="regionInfo.summaryLinkAppleFree" class="link" :href="regionInfo.summaryLinkAppleFree" target="_blank">DL</a>
          <template v-else>DL</template>
        </td>
        <td class="region-cell apple">
          <a v-if="regionInfo.summaryLinkAppleGrossing" class="link" :href="regionInfo.summaryLinkAppleGrossing" target="_blank">$$</a>
          <template v-else>$$</template>
        </td>
        <td class="region-cell google">
          <a v-if="regionInfo.summaryLinkGoogleFree" class="link" :href="regionInfo.summaryLinkGoogleFree" target="_blank">DL</a>
          <template v-else>DL</template>
        </td>
        <td class="region-cell google">
          <a v-if="regionInfo.summaryLinkGoogleGrossing" class="link" :href="regionInfo.summaryLinkGoogleGrossing" target="_blank">$$</a>
          <template v-else>$$</template>
        </td>
      </tr>
      <tr>
        <td class="region-cell" :style="Number.isInteger(downloadApple) && downloadApple <= 10 ? 'background-color: #06ff02;' : ''">{{ downloadApple }}</td>
        <td class="region-cell" :style="Number.isInteger(grossingApple) && grossingApple <= 10 ? 'background-color: #06ff02;' : ''">{{ grossingApple }}</td>
        <td class="region-cell" :style="Number.isInteger(downloadGoogle) && downloadGoogle <= 10 ? 'background-color: #06ff02;' : ''">{{ downloadGoogle }}</td>
        <td class="region-cell" :style="Number.isInteger(grossingGoogle) && grossingGoogle <= 10 ? 'background-color: #06ff02;' : ''">{{ grossingGoogle }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ProductRegion',
  props: ['regionInfo'],
  computed: {
    downloadApple: function() {
      if(this.regionInfo.downloadApple === null){
        return '?';
      }
      if (this.regionInfo.downloadApple < 0) {
        return '-';
      }
      return this.regionInfo.downloadApple;
    },
    grossingApple: function() {
      if(this.regionInfo.grossingApple === null){
        return '?';
      }
      if (this.regionInfo.grossingApple < 0) {
        return '-';
      }
      return this.regionInfo.grossingApple;
    },
    downloadGoogle: function() {
      if(this.regionInfo.downloadGoogle === null){
        return '?';
      }
      if (this.regionInfo.downloadGoogle < 0) {
        return '-';
      }
      return this.regionInfo.downloadGoogle;
    },
    grossingGoogle: function() {
      if(this.regionInfo.grossingGoogle === null){
        return '?';
      }
      if (this.regionInfo.grossingGoogle < 0) {
        return '-';
      }
      return this.regionInfo.grossingGoogle;
    },
  }
}
</script>

<style scoped>
.region-rank {
  display: table-cell;
  border: 2px solid;
}

.region-table {
  border-collapse: collapse;
}

.region-cell {
  border: 1px solid;
  text-align: center;
}

.region {
  background-color: #fff0c6;
}

.store {
  padding: 2px 5px;
}

.apple {
  background-color: #dce7f1;
}

.google {
 background-color: #e1ebd6;
}

.link {
  text-decoration: underline;
}

.highlight-ranking {
  background-color: #06ff02;
}
</style>
